import React, { FC, ReactNode, Suspense, useCallback, useState } from "react";
import { navWidth } from "components/LeftMenu/LeftMenu.styles";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import FullscreenImage from "../components/ImageViewer2/FullscreenImage";
import LeftMenu from "../components/LeftMenu/LeftMenu";
import LoadingPage from "../components/LoadingPage/LoadingPage";
import HeaderContainer from "../containers/HeaderContainer/HeaderContainer";
import RightPanel from "../containers/RightPanel/RightPanel";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { Content, ContentWrapper, LayoutWrapper } from "./Layout.styles";

interface LayoutProps {
  children: ReactNode;
  withMenu: boolean;
  rightPanel?: boolean;
  withHeader?: boolean;
}

const Layout: FC<LayoutProps> = ({
  children,
  withMenu,
  withHeader = false,
  rightPanel = false,
}) => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { t } = useTranslation("common");
  const path = pathname?.split("/")[1];

  const title = t(`pages.${path || "home"}`);
  useDocumentTitle(title);

  const handleSetMenuOpen = useCallback(
    (isOpen: boolean) => {
      setIsMenuOpen(isOpen);
    },
    [setIsMenuOpen],
  );

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <LayoutWrapper>
      {rightPanel && <RightPanel />}

      <Suspense fallback={<LoadingPage />}>
        <LeftMenu
          isOpen={isMenuOpen}
          withMenu={withMenu}
          handleSetMenuOpen={handleSetMenuOpen}
        />

        <ContentWrapper>
          {withHeader && (
            <HeaderContainer
              withMenu={withMenu}
              isMenuOpen={isMenuOpen}
              toggleMenu={toggleMenu}
            />
          )}
          <Content>{children}</Content>
          <FullscreenImage leftOffsetByTheme={navWidth} />
        </ContentWrapper>
      </Suspense>
    </LayoutWrapper>
  );
};

export default Layout;
